import axios from "axios";

export const apiWhatsappChannel = axios.create({
  baseURL: "https://whatsapp.paodiario.org", //"http://localhost:3333",
  headers: {
    Authorization: "Bearer " + process.env.REACT_APP_WHATSAPP_API_DB_TOKEN, //TOKEN DB
  },
});

export const createInstance = async (instance_key) => {
  try {
    if (instance_key) {
      const response = await apiWhatsappChannel.get(
        `instance/init?key=${instance_key}`
      );

      if (response.status === 200) {
        return response;
      }
    }
  } catch (error) {
    return new Error(error.message);
  }
};

export const checkWhatsAppNumber = async (instance_key, phone) => {
  console.log(`checkWhatsAppNumber`);
  console.log(`Verificando número do WhatsApp: ${phone}`);

  if (!instance_key) {
    return false;
  }
  try {
    const response = await apiWhatsappChannel.get(
      `misc/onwhatsapp?key=${instance_key}&id=${phone}`
    );
    if (response?.data?.data) {
      return phone;
    } else {
      throw new Error("Número do WhatsApp não encontrado");
    }
  } catch (error) {
    let phoneWith9;
    if (phone.length === 12) {
      phoneWith9 = phone.slice(0, 4) + "9" + phone.slice(4);
    } else {
      phoneWith9 = phone.slice(0, 4) + phone.slice(5);
    }
    // Tenta novamente inserindo o 9 após o DDD
    console.log(`checkWhatsAppNumber phoneWith9: ${phoneWith9}`, phone);
    const retryResponse = await apiWhatsappChannel.get(
      `misc/onwhatsapp?key=${instance_key}&id=${phoneWith9}`
    );

    console.log(
      `checkWhatsAppNumber retryResponse: ${JSON.stringify(retryResponse.data)}`
    );
    if (!retryResponse.data.data) {
      return false;
    } else {
      return phoneWith9;
    }
  }
};

export const sendText = async (instance_key, phone, message) => {
  try {
    if (instance_key) {
      const params = new URLSearchParams();
      params.append("id", phone);
      params.append("message", message);

      const response = await apiWhatsappChannel.post(
        `message/text?key=${instance_key}`,
        params,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );

      if (response.status === 200) {
        return response;
      }
    }
  } catch (error) {
    return new Error(error.message);
  }
};

export const sendDocument = async (instance_key, phone, filename, file) => {
  try {
    if (instance_key) {
      const formData = new FormData();
      formData.append("id", phone);
      formData.append("filename", filename);
      formData.append("file", file);

      const response = await apiWhatsappChannel.post(
        `message/doc?key=${instance_key}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        return response;
      }
    }
  } catch (error) {
    return new Error(error.message);
  }
};

export const generateQRCode = async (instance_key) => {
  try {
    if (instance_key) {
      const qrCode = await apiWhatsappChannel.get(
        `instance/qrbase64?key=${instance_key}`
      );

      return qrCode;
    }
  } catch (error) {
    return new Error(error.message);
  }
};

export const instanceInfo = async (instance_key) => {
  try {
    const response = await apiWhatsappChannel.get(
      `instance/info?key=${instance_key}`
    );

    return response;
  } catch (error) {
    return new Error(error.message);
  }
};

export const listAllSessions = async () => {
  try {
    const response = await apiWhatsappChannel.get("instance/list");

    return response;
  } catch (error) {
    return new Error(error.message);
  }
};

export const listAllInstances = async () => {
  try {
    const response = await apiWhatsappChannel.get("instance/list");
    const allInstanceKey = response.data.data.map(({ instance_key }) => [
      instance_key.toString(),
    ]);
    return allInstanceKey;
  } catch (error) {
    return new Error(error.message);
  }
};

export const logoutSession = async (instance_key) => {
  try {
    await apiWhatsappChannel.delete(`instance/logout?key=${instance_key}`);

    return true;
  } catch (error) {
    return new Error(error.message);
  }
};
export const deleteInstance = async (instance_key) => {
  try {
    await apiWhatsappChannel.delete(`instance/delete?key=${instance_key}`);
  } catch (error) {
    return new Error(error.message);
  }
};

export const deleteAllInstances = async () => {
  const sessionsToDeleted = await listAllInstances();

  if (sessionsToDeleted) {
    for (let index = 0; index < 300; index++) {
      const sessionKey = sessionsToDeleted[index];
      const key = sessionKey[0];

      await apiWhatsappChannel.delete(`instance/delete?key=${key}`);
    }
  } else {
    throw new Error("No sessions to delete");
  }
};
